import React from "react";
import { Grid } from "@mui/material";
import BottomLinks from "../BottomLinks";
import Footer from "../Footer";
import PostSingle from "../PostSingle";

export default function Text() {
  return (
    window.scrollTo(0, 0),
    (
      <div>
        <Grid container>
          <Grid item xs={0} sm={0} md={1}></Grid>
          <Grid item xs={12} sm={12} md={10}>
            <PostSingle props={data} />
            <BottomLinks />
          </Grid>
        </Grid>

        <Footer />
      </div>
    )
  );
}

const data = {
  image:
    "https://images.unsplash.com/photo-1638205641601-eeb448225cd8?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxlZGl0b3JpYWwtZmVlZHwxNHx8fGVufDB8fHx8&auto=format&fit=crop&w=800&q=60",
  title: (
    <>
      دازاین
      <br />
      Dasein
    </>
  ),
  text: (
    <>
      برای آن‌که بتوانیم پرسشِ فراموش شده‌ی هستی را بار دیگر طرح ریزیم، به
      هستنده‌ایی ویژه‌ نیازمندیم. هستنده‌ای که هماره و پیشاپیش در فهمی از هستی
      حرکت می‌کند. هستنده‌ای که به پشتوانه‌ی همین فهمِ هستی، گرایشی به تلاش
      برایِ فهمِ مفهومِ آن را در سر می‌پروراند. هستنده‌ای که بر هستیِ خود، آگاه
      بوده و به گونه‌ای با این هستی در ارتباط است. این ارتباط اما نه از جنسِ
      ارتباط میان دو موضوعِ به وضوح جدا از هم، بل‌که ارتباطی‌ست پیوسته. ارتباطی
      میان ِ دو پدیده‌ی درهم‌آمیخته، به شکلی که این هستنده‌ی ویژه، هستی‌مندیِ
      خود را از آن هستنده دریافت می‌کند و خود را در او «در»می‌یابد، با این حال
      هماره فاصله‌ایی میانِ آن‌هاست و هر یک هویتی جدای دیگری دارد. یکی هستنده
      است و دیگری هستیِ هستنده. این هستنده‌ی ویژه‌ می‌تواند درباره‌ی معنایِ
      هستیِ خود، از خود پرسش نماید. یک هستنده‌ی از هستیِ خویش آگاهِ پرسش‌گر که
      آن را دازاین Das Dasein می‌نامیم. دازاین به شکلی پیشاتئوریک و پیوسته،
      در-جهان-هستنِ in-der-Welt-sein خود را می‌فهمد و «ارتباطِ» پیوسته‌ی خود را
      با خود و تعامل‌اش (کنش متقابل، عمل دوسویه) Umgang در جهانِ پیرامون‌اش را
      درمی‌یابد (GA-2 : §15). دازاین، پیوسته و به طور ضمنی implitzit دارایِ
      ویژگی‌های: جهان‌فهمی، هستی‌فهمی و خودفهمی است و این ویژگی‌ها، نقطه‌ی
      مقابلِ سوژه‌ی تئوریکِ ایزوله‌ی شناسای مدرنِ «گسسته» از جهان‌ است.
      <p></p>
      <b> دازاین؟</b>
      <br />
      دازاین در کنارِ هستیِ دازاین و زمان‌مندیِ دازاین، محوری‌ست که بخش‌های
      مختلف کتاب به دورِ آن در حال گردش‌اند و به ما رخ می‌نمایند:
      <p>
        <center>
          <cite>
            این هستنده که خودِ ماییم و علاوه بر چیزهای دیگر از امکانِ‌وجودیِ
            پرسیدن برخوردار است را با اصطلاح دازاین مشخص می‌کنیم. (GA-2 - §2)
          </cite>
        </center>
      </p>
      <p>
        اما اگر دازاین خودِ ماییم، چرا هایدگر از واژه های آشنایی هم‌چون: انسان،
        انسانِ خردمند، انسانِ ناطق، بشر، سوژه، سوژه‌ی شناسا، سوژه‌ی اندیشنده،
        منِ استعلایی، روح، جان و… برای شرحِ اندیشه‌ی خود بهره نمی‌جوید؟ دلیلِ
        پرهیز او از این واژه‌ها چیست؟ آیا قصد فیلسوف از برگزیدنِ این نامِ
        «ناآشنا»، گمراه کردنِ ماست؟
        <p></p>
        می‌توان هدف از برگزیدن این واژه را در دو لایه بررسی نمود. نخست
        آشنایی‌زدایی: تمامِ واژگانی که در بالا طرح شدند، ریشه در سنتِ فلسفی و
        فلسفه‌های شناخت‌شناسانه دارند. واژگانی که از اعماقِ متافیزیکِ مدرن
        سربرآورده‌اند و خود را چونان بختگی بر جهانِ فکری و زبانیِ ما
        «چسبانده‌اند». بسیاری از انسان‌ها، بی‌آن‌که حتا با فلسفه آشنایی داشته
        باشند، تجسم و فهمشی سوژه/ابژه محور از انسان را در سرمی‌پرورانند: انسان
        به مثابه تافته‌ایی خرمند و روح‌مند و جدا بافته نسبت به «بقیه‌»ی جهان!
        منِ جدا از جهان، می‌اندیشم، پس هستم! واژه‌ی دازاین، ارتباطِ تاریخی میانِ
        مفهومِ انسان و سنتِ فلسفی را از هم می‌گسلد و ما را به بازتعریف و
        «نوسازیِ» مفهومِ انسان وامی‌دارد. دوم: ویژگیِ مهمِ دازاین که خود را از
        نام‌های برآمده از سنتِ فلسفی ممتاز می‌کند، زمان‌مندیِ اوست. برای درکِ
        دازاین Dasein می‌بایستی مفهومِ آن را از «فعلِ» sein که به معنای
        بودن/هستن/وجود داشتن است استخراج کنیم و نه از اسمِ Das Sein که به معنایِ
        هستی/وجود است. بودن/هستن/وجود داشتن، زمان‌مند است و پویا و میرا. بودم،
        هستم و خواهم بود. در مقابل، هستی/وجود صُلب است و سخت و بی زمان و نامیرا.
        <p></p>
        دازاین زمان‌مند است و میرا و پیوسته با هستیِ خود به نوعی در ارتباط است.
        این ارتباطِ هماره و پیوسته‌ی او با هستیِ خودش را «اگزیستنس» می نامیم.
        وجه‌ی ممتازِ دازاین، اگزیستن داشتنِ اوست و نه خردمند بودن‌اش. دازاین خود
        را در اگزیستنس‌اش درمی‌یابد: یعنی در فهمِ هستی‌اش و ارتباطِ پیوسته اش با
        هستی ِ خود. او هستنده‌ی میرایی‌ست که می‌بایست به عنوانِ «امکانی»
        زمان‌مند فهمیده شود. امکانی در بازه‌ی زمان. امکانی پویا، متغیر و در
        جریان. امکانی که با مرگ به پایان می‌رسد. هم‌چون یک بازیِ کامپیوتری که
        امکانی‌ست برای پشتِ سرگذاردنِ مرحله‌های مختلفِ بازی و این امکان با مرگِ
        شخصیتِ بازی، به عدم امکان بدل می‌شود. هم‌چون فیلمی سینمایی که در افق
        زمان در جریان است و تا پایانِ آخرین سکانس، امکانِ حادثه‌ آفرینی دارد، با
        این تفاوت که یک بازیِ کامپیوتری و یا یک فیلمِ سینمایی از هستیِ خود، آگاه
        نیستند و نمی‌توانند درباره‌ی هستومندیِ خود بیاندیشند، اما دازاین علاوه
        بر «امکانی» زمان‌مند بودن، از هستومندیِ خود، آگاه است، حتا اگر هرگز بدان
        نیاندیشد، با این حال آن را پیوسته درمی‌یابد. دازاین Da-sein و «امکان
        داشتن» Möglich-sein دو رویِ جداناپذیرِ یک سکه‌اند. درازاین یک «چیز»
        نیست، بل‌که یک رویدادِ زمان‌مند است. یک تاریخ است. درازاین در زمان
        می‌اگزیید Dasein existiert. حال پرسش آن است که این اگزیدن چه ویژگی‌هایی
        دارد؟ درازاین چه‌گونه می‌اگزیید؟
      </p>
    </>
  ),
};
